/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOpportunityDto
 */
export interface UpdateOpportunityDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    expectedRevenue?: number;
    /**
     *
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    recurringRevenue?: number;
    /**
     *
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    recurringPlanId?: number | null;
    /**
     *
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    typeOfSale?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    salesFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    priority?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    dateDeadline?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    partnerId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    salesEngineer?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    crmBusinessProvider?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOpportunityDto
     */
    stageId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateOpportunityDto
     */
    orderIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOpportunityDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateOpportunityDto interface.
 */
export function instanceOfUpdateOpportunityDto(value: object): value is UpdateOpportunityDto {
    return true;
}

export function UpdateOpportunityDtoFromJSON(json: any): UpdateOpportunityDto {
    return UpdateOpportunityDtoFromJSONTyped(json, false);
}

export function UpdateOpportunityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOpportunityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'expectedRevenue': json['expected_revenue'] == null ? undefined : json['expected_revenue'],
        'recurringRevenue': json['recurring_revenue'] == null ? undefined : json['recurring_revenue'],
        'recurringPlanId': json['recurring_plan'] == null ? undefined : json['recurring_plan'],
        'typeOfSale': json['type_of_sale'] == null ? undefined : json['type_of_sale'],
        'salesFamily': json['sales_family'] == null ? undefined : json['sales_family'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dateDeadline': json['date_deadline'] == null ? undefined : json['date_deadline'],
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'partnerId': json['partner_id'] == null ? undefined : json['partner_id'],
        'salesEngineer': json['sales_engineer'] == null ? undefined : json['sales_engineer'],
        'crmBusinessProvider': json['crm_business_provider'] == null ? undefined : json['crm_business_provider'],
        'stageId': json['stage_id'] == null ? undefined : json['stage_id'],
        'orderIds': json['order_ids'] == null ? undefined : json['order_ids'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function UpdateOpportunityDtoToJSON(json: any): UpdateOpportunityDto {
    return UpdateOpportunityDtoToJSONTyped(json, false);
}

export function UpdateOpportunityDtoToJSONTyped(value?: UpdateOpportunityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'expected_revenue': value['expectedRevenue'],
        'recurring_revenue': value['recurringRevenue'],
        'recurring_plan': value['recurringPlanId'],
        'type_of_sale': value['typeOfSale'],
        'sales_family': value['salesFamily'],
        'priority': value['priority'],
        'date_deadline': value['dateDeadline'],
        'user_id': value['userId'],
        'partner_id': value['partnerId'],
        'sales_engineer': value['salesEngineer'],
        'crm_business_provider': value['crmBusinessProvider'],
        'stage_id': value['stageId'],
        'order_ids': value['orderIds'],
        'description': value['description'],
    };
}

